import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Expiring, HtlService } from "../../htl/htl.service";
import moment from "moment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { HoldItemList } from "../../shared/models/holdItemList.model";
import { LocalStorageService } from "../../shared/local-storage.service";
import { HHMM } from "@rrsolutionsit/atl-utils";

@Component({
    selector: "app-update-expiring-hold-item-list-dialog",
    templateUrl: "./update-expiring-hold-item-list-dialog.component.html",
    styleUrls: ["./update-expiring-hold-item-list-dialog.component.scss"],
    standalone: false,
})
export class UpdateExpiringHoldItemListDialogComponent implements OnInit {
    public hilExpiringFormGroup: FormGroup;

    private _userSession;

    public showFlightNumber = false;

    public helicopterData;
    public totalHours: string;
    public totalCycles: number;

    constructor(
        public dialogRef: MatDialogRef<UpdateExpiringHoldItemListDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        private _data: {
            holdItemListid: number;
            holdItem: HoldItemList;
            showFlightNumber: boolean;
            helicopterData: any;
        },
        private _formBuilder: FormBuilder,
        private _htlService: HtlService,
        private _snackBar: MatSnackBar,
        private _translate: TranslateService,
        private _localStorageService: LocalStorageService,
    ) {
        this._userSession = this._localStorageService.getUserLocalStorageObject();
        this.hilExpiringFormGroup = this._formBuilder.group({
            id: [this._data.holdItemListid],
            exe1Document: [""],
            exe1Date: [""],
            exe1FlightHours: [""],
            exe1FlightNumber: [""],
            exe1Cycles: [""],
            exe2Document: [""],
            exe2Date: [""],
            exe2FlightHours: [""],
            exe2FlightNumber: [""],
            exe2Cycles: [""],
        });

        if (this._data.showFlightNumber) {
            this.showFlightNumber = this._data.showFlightNumber;
        }

        if (this._data.helicopterData) {
            this.helicopterData = this._data.helicopterData;
            this.totalHours = HHMM.sumTimes(this.helicopterData?.totalHours, this.helicopterData?.flightSUM).value;
            this.totalCycles = this.helicopterData?.totalCycles + this.helicopterData?.currentCycles;
        }
    }

    ngOnInit(): void {
        this.hilExpiringFormGroup.controls["exe1Document"].setValue(this._data.holdItem.exe1Document);
        this.hilExpiringFormGroup.controls["exe1Date"].setValue(this._data.holdItem.exe1Date);
        this.hilExpiringFormGroup.controls["exe1FlightHours"].setValue(this._data.holdItem.exe1FlightHours);
        this.hilExpiringFormGroup.controls["exe1FlightNumber"].setValue(this._data.holdItem.exe1FlightNumber);
        this.hilExpiringFormGroup.controls["exe1Cycles"].setValue(this._data.holdItem.exe1Cycles);
        this.hilExpiringFormGroup.controls["exe2Document"].setValue(this._data.holdItem.exe2Document);
        this.hilExpiringFormGroup.controls["exe2Date"].setValue(this._data.holdItem.exe2Date);
        this.hilExpiringFormGroup.controls["exe2FlightHours"].setValue(this._data.holdItem.exe2FlightHours);
        this.hilExpiringFormGroup.controls["exe2FlightNumber"].setValue(this._data.holdItem.exe2FlightNumber);
        this.hilExpiringFormGroup.controls["exe2Cycles"].setValue(this._data.holdItem.exe2Cycles);
    }

    onFormSubmit() {
        const expiring = this.hilExpiringFormGroup.value as Expiring;
        expiring.exe1Date = expiring.exe1Date !== "" ? moment(expiring.exe1Date).format("YYYY-MM-DD") : "";
        expiring.exe2Date = expiring.exe2Date !== "" ? moment(expiring.exe2Date).format("YYYY-MM-DD") : "";
        this._htlService.updateExpiringOfHoldItemList(expiring, this._userSession.username).subscribe((result) => {
            this.dialogRef.close();
            this._snackBar.open(this._translate.instant("GENERAL.savedSuccessMsg"), this._translate.instant("GENERAL.close"), {
                duration: 3000,
            });
        });
    }
}
